import { useAppSelector } from 'hooks/redux';
import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import FormValidationDark from 'assets/illustrations/Forms-validation-dark.svg';
import FormValidation from 'assets/illustrations/Forms-validation.svg';
import IDVerifyDark from 'assets/illustrations/Identity-verification-dark.svg';
import IDVerify from 'assets/illustrations/Identity-verification.svg';
import SavingsTransferDark from 'assets/illustrations/Savings-transfer-dark.svg';
import SavingsTransfer from 'assets/illustrations/Savings-transfer.svg';

const imgStyle = { marginBottom: 24, height: 'auto', width: 96 };

const SetupPage = () => {
  const theme = useTheme();

  const a2AInvestments = useAppSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'a2AInvestmentAccounts'),
  );

  return (
    <Box textAlign='center' pl={3} pr={3} pt={2} pb={4}>
      <Typography variant='titleMedium'>
        {a2AInvestments
          ? 'Transfer funds to your checking, savings, or investment accounts—all in Simplifi!'
          : 'Transfer funds to your checking or savings accounts—all in Simplifi!'}
      </Typography>
      <Box display='flex' alignItems='center' mt={8} justifyContent='space-between' pl={2} pr={2}>
        <Box display='flex' flexDirection='column' alignItems='center' maxWidth={175}>
          <img style={imgStyle} alt='no transactions' src={theme.palette.mode === 'dark' ? IDVerifyDark : IDVerify} />
          <Typography variant='bodyRegular'>Add details so we can verify you&apos;re the account holder</Typography>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' maxWidth={175}>
          <img
            style={imgStyle}
            alt='no transactions'
            src={theme.palette.mode === 'dark' ? FormValidationDark : FormValidation}
          />
          <Typography variant='bodyRegular'>Register your accounts to participate in transfers</Typography>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' maxWidth={175}>
          <img
            style={imgStyle}
            alt='no transactions'
            src={theme.palette.mode === 'dark' ? SavingsTransferDark : SavingsTransfer}
          />
          <Typography variant='bodyRegular'>Use Simplifi to transfer funds between your accounts</Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default SetupPage;
